import { ProjectFileSection, ProjectFileUsage } from 'src/utils/enums'
import { ProjectFileUsageMeta } from 'src/utils/projectFiles'

export const sectionForUsage = (
  usage: ProjectFileUsage
): ProjectFileSection => {
  const meta = ProjectFileUsageMeta[usage]
  return (meta?.section as ProjectFileSection) ?? ProjectFileSection.OTHER_DOCUMENTS
}

export const SECTION_ORDER: readonly ProjectFileSection[] = [
  ProjectFileSection.ADMINISTRATIVE,
  ProjectFileSection.PICTURES,
  ProjectFileSection.TOWN_PLANNING,
  ProjectFileSection.DESIGN,
  ProjectFileSection.OTHER_DOCUMENTS,
]
